import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-skeleton ant-skeleton-active css-eq3tly"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-skeleton-content" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ant-skeleton-paragraph" }, [
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Cadastrar", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_produto_modal = _resolveComponent("produto-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.aguardarConclusaoCarregamento(_ctx.computedCodigoSelecionado))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createBlock(_component_a_select, {
          key: 1,
          value: _ctx.computedCodigoSelecionado,
          ref: "refSelecionarProduto",
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.computedCodigoSelecionado = $event)),
          onChange: _ctx.change,
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focus())),
          onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pesquisarProduto($event))),
          onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false)),
          "show-search": "",
          optionFilterProp: "label",
          class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          filterOption: false,
          "not-found-content": _ctx.selecionarBase.buscandoDados ? undefined : null,
          disabled: _ctx.props.disabled,
          title: _ctx.props.title,
          "data-coluna": _ctx.props.dataAttributeColuna,
          listHeight: 160
        }, _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaDefinicoes, (definicaoProduto) => {
              return (_openBlock(), _createBlock(_component_a_select_option, {
                key: definicaoProduto.codigo,
                value: definicaoProduto.codigo,
                class: _normalizeClass(definicaoProduto.codigo === 0? 'ss-opcao-btn':'')
              }, {
                default: _withCtx(() => [
                  (definicaoProduto.codigo === 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cadastrar && _ctx.cadastrar(...args)), ["stop"])),
                        class: "ant-btn ant-btn-primary ant-btn-sm ss-btn-opcao ss-tamanho-completo",
                        type: "button"
                      }, _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(definicaoProduto.codigoInterno) + " - " + _toDisplayString(definicaoProduto.produto), 1))
                ]),
                _: 2
              }, 1032, ["value", "class"]))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.selecionarBase.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando Produtos "),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["value", "onChange", "class", "allowClear", "placeholder", "not-found-content", "disabled", "title", "data-coluna"])),
    (_ctx.props.apresentarCadastro)
      ? (_openBlock(), _createBlock(_component_produto_modal, {
          key: 2,
          visivel: _ctx.selecionarBase.apresentarCadastro,
          "onUpdate:visivel": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selecionarBase.apresentarCadastro) = $event)),
          operacao: _ctx.selecionarBase.operacaoCadastro,
          produtoPreCadastro: _ctx.props.produtoPreCadastro,
          onCadastroConcluido: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cadastroConcluido($event)))
        }, null, 8, ["visivel", "operacao", "produtoPreCadastro"]))
      : _createCommentVNode("", true)
  ]))
}